import { FC } from 'react';
import { Menu } from 'antd';
import { createSearchParams, useNavigate } from 'react-router';

import styles from './styles.module.scss';

import { useNavMenu } from '@/hooks';
import { CUSTOMERS_DEFAULT_SORT } from '@/modules/customers';
import { EAdminRoutes } from '@/services/router/enums.ts';

export const NavMenu: FC = () => {
    const [items, selectedKeys] = useNavMenu();
    const navigate = useNavigate();

    const onClick = (key: EAdminRoutes): void => {
        switch (key) {
            case EAdminRoutes.Customers:
                navigate({
                    pathname: key,
                    search: createSearchParams(CUSTOMERS_DEFAULT_SORT).toString(),
                });
                break;
            default:
                navigate(key);
                break;
        }
    };

    return (
        <div className={styles.menu}>
            <Menu
                items={items}
                mode="inline"
                selectedKeys={selectedKeys}
                onClick={({ key }) => onClick(key as EAdminRoutes)}
            />
        </div>
    );
};
